import Patient from './patient';
import Patients from './patients';
import NoMatch from './no-match';
import AddPatient from './add-patient';
import Auth from './auth';

export {
  Patient,
  Patients,
  AddPatient,
  NoMatch,
  Auth
}



// WEBPACK FOOTER //
// ./src/pages/index.js